import { connect } from "react-redux"

import {
    sourceSetEditMode,
    sourceItemDeleteRequest,
} from "../../../../actions/source-actions"
import ViewFormActionButtonsWidget from "../../../common/ViewFormActionButtonsWidget"

const mapStateToProps = ({ presentation, authentication }) => ({
    canEdit: authentication.permissions.indexOf("w_source") !== -1,
    canDelete: authentication.permissions.indexOf("w_source") !== -1,
    showDelete: true,
    activeId: presentation.sources.activeId,
    isDeleting: presentation.sources.isDeletingItem,
    name: presentation.sources.workingModel.name,
    type: "source",
})

const mapDispatchToProps = (dispatch) => ({
    onEdit: () => dispatch(sourceSetEditMode(true)),
    onDelete: (id) => dispatch(sourceItemDeleteRequest(id)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewFormActionButtonsWidget)
